import { get } from "lodash";

export const extendSliceWithAssignees = ({
  rootPath,
  actionName = "setAssignees",
} = {}) => ({
  [actionName]: (state, { payload }) => {
    const entity = get(state, rootPath);

    if (!entity) {
      return;
    }

    entity.assignees = payload || [];
  },
});
